import { participantApi } from '../api'
import { setApplicationsList, setCurrentApplication } from '../store/participant/applications/slice'
import { setEventsList, setCurrentEvent } from '../store/participant/events/slice'
import { setLoading } from '../store/participant/loading/slice'


export const getEvents = (params) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await participantApi.getEvents(params)
    dispatch(setEventsList(response.data.data))
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}

export const getEvent = (eventId) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await participantApi.getEvent(eventId)
    dispatch(setCurrentEvent(response.data.data))
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}

export const getApplications = (params) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await participantApi.getApplications(params)
    dispatch(setApplicationsList(response.data.data))
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}

export const getApplication = (applicationId) => async (dispatch) => {
  try {
    // dispatch(setLoading(true))
    const response = await participantApi.getApplication(applicationId)
    dispatch(setCurrentApplication(response.data.data))
  } catch (error) {
    console.log(error)
  } finally {
    // dispatch(setLoading(false))
  }
}

export const createApplication = (eventId, data) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await participantApi.createApplication(eventId, data)
    return response.data
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}

export const updateApplication = (applicationId, data) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await participantApi.updateApplication(applicationId, data)
    return response.data
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}

export const deleteApplication = (applicationId) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    await participantApi.deleteApplication(applicationId)
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}
